<template>
  <div>
    <h1 class="select-base-layer-text white--text">Selecione o padrão visual do mapa</h1>
    <v-radio-group v-model="baseLayerSelected" row @change="changeBaseLayer">
      <div v-for="(baseLayer, index) in baseLayers" :key="index">
        <v-radio color="secondary lighten-1" :value="baseLayer.title">
          <template v-slot:label>
            <span class="base-layer-title">{{baseLayer.exibition}}</span>
          </template>
        </v-radio>
      </div>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: "NewBaseLayersMapMenu",
  props:['baseLayers','initialBaseLayer'],
  data: ()=>({
    baseLayerSelected: undefined
  }),
  created(){
    this.baseLayerSelected = this.initialBaseLayer;
  },
  methods:{
    changeBaseLayer(value){
      this.$emit('changeBaseLayer',value)
    }
  }
}
</script>
<style scoped>
  .select-base-layer-text{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
  }
  .base-layer-title{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
  }
</style>
